/**
 * SGKC007A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc007aReqTankatableShutokuinfoDto {

    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 単価表登録管理通番
     */
    tankatableregistrationManagementserialnumber?: string;
}

